import React from 'react'
import styled from 'styled-components'
import { Modal } from 'pcln-modal'
import { Button, Flex } from 'pcln-design-system'
import { ArrowLeft } from 'pcln-icons'

const FlexButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.height};

  &:focus {
    box-shadow: none;
  }
`

export interface IInputModalProps {
  borderRadius?: string
  className?: string
  children: React.ReactNode
  height?: number | string | Array<number | string>
  id: string
  imgMode?: boolean
  input: React.ReactElement
  isOpen: boolean
  zIndex: number
  onClose: (evt: React.ChangeEvent<HTMLButtonElement>) => void
}

/** @public */
const InputModal = ({
  borderRadius = 'lg',
  className,
  children,
  height = '48px',
  id,
  imgMode,
  input,
  isOpen,
  onClose,
  zIndex,
}: IInputModalProps) => {
  return (
    <Modal
      ariaLabelledBy={id}
      className={className}
      disableCloseButton
      fullScreen
      header={
        <Flex alignItems='center' width={1} pt={3} px={3}>
          <FlexButton aria-label='Close' borderRadius={borderRadius} height={height} mr={2} onClick={onClose}>
            <ArrowLeft />
          </FlexButton>
          {React.cloneElement(input, { autoFocus: true, height, width: 1 })}
        </Flex>
      }
      imgMode={imgMode}
      isOpen={isOpen}
      timeout={0}
      onClose={onClose}
      zIndex={zIndex}
    >
      {children}
    </Modal>
  )
}

export default InputModal
